import moment from 'moment';
import { isSessionOverlaping, isUpcomingSession } from './scheduleFilters';
import meetingState from '../constants/meetingState';
import { isCurrentSession } from './schedule/isCurrentSession';

// Alias for isCurrentSession
export const isCurrentMeeting = isCurrentSession;

// Alias for isUpcomingSession
export const isUpcomingMeeting = isUpcomingSession;

/**
 * Filter for starting meetings
 * @param {object} meeting Meeting object
 * @param {number} tolerance Number of minutes after start where it should still return true (default 5)
 * @returns boolean
 */
// QUESTION: can't this be replaced with isUpcomingMeeting, now that it's shared with the schedule one?
export const startingMeetingFilter = (
    meeting,
    beforeStartTolerance = 0,
    afterStartTolerance = 5
) => {
    const start = moment(meeting.start_local).subtract(
            beforeStartTolerance,
            'minutes'
        ),
        end = moment(meeting.start_local).add(afterStartTolerance, 'minutes');
    return (
        beforeStartTolerance + afterStartTolerance > 0 &&
        moment().isBetween(start, end, null, '[)') &&
        moment().isSameOrBefore(meeting.end_local)
    );
};

// Alias for isSessionOverlaping
export const isMeetingOverlaping = isSessionOverlaping;

/**
 * Returns true if a meeting can be cancelled
 * @param {object} meeting Meeting object
 */
export function isMeetingCancellable(meeting) {
    return (
        isUpcomingMeeting(meeting) &&
        [meetingState.CONFIRMED, meetingState.PENDING].includes(meeting._state)
    );
}
